module.exports = __webpack_public_path__ + "media/images/product-stage-background-941343261f835b106edef72ed11affa0.svg";